/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_Post_ContentInputs */

const en_placeholder_post_content = /** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share what's happening with your brand...`)
};

const es_placeholder_post_content = /** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte lo que está sucediendo con tu marca...`)
};

const fr_placeholder_post_content = /** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagez ce qui se passe avec votre marque...`)
};

const de_placeholder_post_content = /** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile mit, was mit deiner Marke passiert...`)
};

const id_placeholder_post_content = /** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan apa yang sedang terjadi dengan merek Anda...`)
};

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const ja_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const zh_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const ar_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const it_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const ru_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const pt_placeholder_post_content = en_placeholder_post_content;

/** @type {(inputs: Placeholder_Post_ContentInputs) => LocalizedString} */
const ko_placeholder_post_content = en_placeholder_post_content;

/**
* | output |
* | --- |
* | "Share what's happening with your brand..." |
*
* @param {Placeholder_Post_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_post_content = /** @type {((inputs?: Placeholder_Post_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_Post_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_post_content(inputs)
	if (locale === "es") return es_placeholder_post_content(inputs)
	if (locale === "fr") return fr_placeholder_post_content(inputs)
	if (locale === "de") return de_placeholder_post_content(inputs)
	if (locale === "ja") return ja_placeholder_post_content(inputs)
	if (locale === "zh") return zh_placeholder_post_content(inputs)
	if (locale === "ar") return ar_placeholder_post_content(inputs)
	if (locale === "id") return id_placeholder_post_content(inputs)
	if (locale === "it") return it_placeholder_post_content(inputs)
	if (locale === "ru") return ru_placeholder_post_content(inputs)
	if (locale === "pt") return pt_placeholder_post_content(inputs)
	return ko_placeholder_post_content(inputs)
});